export class YearModel {
    public id:number;
    public year_label: string;
    public opening_date: Date;
    public closing_date: Date;
}
